var Pandora = Pandora || {};

Pandora.CompanyAdminHandler = {
  init: function() {
    this._$companySelect = $('#company-admin-company-select');
    this._$userSelect = $('#company-admin-user-select');

    if (!this._$companySelect.length || !this._$userSelect.length) return;

    this._$companySelect.on('change', $.proxy(this._onCompanyChange, this));

    if (!this._$companySelect.val()) {
      this._$userSelect.prop('disabled', true);
    }
  },

  _onCompanyChange: function() {
    var companyId = this._$companySelect.val();

    if (!companyId) {
      this._$userSelect.empty().append('<option value="">Selecciona un usuario</option>');
      this._$userSelect.prop('disabled', true);
      return;
    }

    this._$userSelect.prop('disabled', true);
    this._$userSelect.empty().append('<option value="">Cargando...</option>');

    $.ajax({
      url: '/admin/company_admins/users_for_company',
      data: { company_id: companyId },
      dataType: 'json',
      context: this,
      success: function(users) {
        this._$userSelect.empty().append('<option value="">Selecciona un usuario</option>');

        $.each(users, $.proxy(function(_, user) {
          this._$userSelect.append($('<option>', { value: user.id, text: user.label }));
        }, this));

        this._$userSelect.prop('disabled', false);
      },
      error: function() {
        this._$userSelect.empty().append('<option value="">Error al cargar usuarios</option>');
        this._$userSelect.prop('disabled', true);
      }
    });
  }
};
